import { IContainerProps } from 'props';
import styled from 'styled-components';

export const Container = styled.div<IContainerProps>`
  width: 85%;
  max-width: 100rem;
  position: relative;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme, color }) => theme.colors[color]};

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: baseline;

  p {
    font-size: 1.3rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.primary};
  }

  .input-button {
    width: 100%;
    display: flex;
    gap: 1rem;
    align-items: baseline;
  }
`;
